"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var reselect_1 = require("reselect");
var utils_1 = require("../../utils/utils");
var constants_1 = require("./constants");
var moduleState = function (rootState) { return rootState[constants_1.namespace]; };
exports.isFullScreen = reselect_1.createSelector(moduleState, function (state) { return state.isFullScreen; });
exports.isChromecastDevicesVisible = reselect_1.createSelector(moduleState, function (state) { return state.isChromecastDevicesVisible; });
exports.isContentRestricted = reselect_1.createSelector(moduleState, function (state) {
    return utils_1.isNotNilOrEmpty(state.restrictedMessage);
});
exports.restrictedMessage = reselect_1.createSelector(moduleState, function (state) { return state.restrictedMessage; });
exports.getLastCheckedContent = reselect_1.createSelector(moduleState, function (state) { return state.lastCheckedContent; });
exports.getPlayerState = reselect_1.createSelector(moduleState, function (state) { return state.playerState; });
//# sourceMappingURL=selectors.js.map